<style>
	.el-dialog__body {
		padding: 0 20px 20px 20px!important;
	}
	.form-line {
		display: flex;
		flex-direction: row;
		min-height: 50px;
		line-height: 30px;
		font-size: 16px;
		align-items: center;
	}
	.form-name {
		width: 100px;
		text-align: right;
	}
	.flex-row {
		display: flex;
		flex-direction: row;
		align-items: center;
	}
</style>
<template>
	<div>
		<div  class='flex-row' style="border-bottom: solid 1px #dcdcdc; margin-bottom: 10px;">
			<el-radio-group v-model="wallet_type" @input="WalletTypeChange">
				<el-radio-button label="红钻钱包"></el-radio-button>
				<el-radio-button label="蓝钻钱包"></el-radio-button>
			</el-radio-group>
			<div class='flex-row' style="margin-left: 20px; height: 60px; font-size: 16px;">
				<div style="color: red;">红钻：</div>
				<div>{{info.gold}}</div>
				&nbsp;&nbsp;&nbsp;&nbsp;
				<div style="color: #3399ff;">蓝钻：</div>
				<div>{{info.balance}}</div>
			</div>
		</div>
		
		<div class="flex-row" style="padding-bottom: 10px; border-bottom: solid 1px #dcdcdc; margin-bottom: 10px;">
			<div class="flex-row">
				<el-radio-group v-model="change_type" size="mini" fill="#712354">
					<el-radio-button label="其他"></el-radio-button>
					<el-radio-button label="赠送"></el-radio-button>
				</el-radio-group>
			</div>
			<div class="flex-row" style="margin-left: 10px;">
				<el-radio-group v-model="action_type" size="mini" fill="#856856">
					<el-radio-button label="增加"></el-radio-button>
					<el-radio-button label="减少"></el-radio-button>
				</el-radio-group>
			</div>
			<el-input type="number" v-model="amount" placeholder="操作数目" size="mini" style="width: 120px; margin-left: 10px;"></el-input>
			
			<el-input placeholder="备注" v-model="remarks" size="mini" style="width: 160px; margin-left: 10px;"></el-input>
			<el-button type="primary" size="mini" style="margin-left: 10px;" @click="submitPay()">确认</el-button>
			
			<el-button type="danger" size="mini" style="margin-left: 10px;" @click="getRecord(true)">刷新</el-button>
		</div>
		<div>
			<div style="height: 20px; line-height: 20px; font-size: 14px; margin-bottom: 10px;">帐变记录</div>
			
			<el-table :data="tableData" height="530" border style="width: 100%">
				<el-table-column prop="id" label="记录编号" align="center" width="90"></el-table-column>
				<el-table-column prop="change_balance" label="变化" align="center" width="100"></el-table-column>
				<el-table-column prop="after_balance" label="余额" align="center" width="100"></el-table-column>
				<el-table-column prop="reason" label="原因" align="center"> </el-table-column>
				<el-table-column prop="add_time" label="时间" align="center" width="200"> </el-table-column>
			</el-table>
			<div  style="flex-grow: 1; display: flex; flex-direction: row; justify-content: flex-end; margin: 10px 10px 10px 0;">
			<el-pagination
			      @size-change="handleSizeChange"
			      @current-change="handleCurrentChange"
			      :current-page="record.page"
			      :page-sizes="[10, 20, 50, 100]"
			      :page-size="record.limit"
			      layout="total, sizes, prev, pager, next, jumper"
			      :total="total">
			    </el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props:['info'],
		data(){
			return {
				tableData:[],
				wallet_type:'红钻钱包',
				action_type:'增加',
				change_type:'其他',
				
				record:{
					uid:0,
					types:1,
					page:1,
					limit:10
				},
				total:0,
				amount:'',
				remarks:''
			}
		},
		created() {
			this.record.uid = this.info.uid;
			this.getRecord(true);
		},
		methods:{
			actionApi(_form){
				let _this = this;
				_this.loading = true;
				_this.$api.post("/User/changeBalance", _form).then(res=>{
					_this.loading = false;
					if(res.code == 200){
						_this.$message({ message: '操作成功', type: 'success', });
					}else{
						_this.$message({ message: res.msg, type: 'warning', });
					}
				}).catch(res=>{
					_this.loading = false;
				});
			},
			actionFunc(_form){
				let _this = this;
				this.$confirm('是否确认操作?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					_this.actionApi(_form);
				}).catch(() => {      
				});
			},
			submitPay(){
				let _action = 'add';
				let _wallet = this.record.types;
				let _types = 0;
				if(isNaN(this.amount) || this.amount <= 0){
					this.$message({ message: '请输入正确操作金额>0', type: 'warning', });
				}
				if(this.change_type == '赠送'){
					_types = 1;
				}
				if(this.action_type == '减少'){
					_action = 'sub';
				}
				if(this.remarks.trim().length == 0){
					this.$message({ message: '请输入备注信息', type: 'warning', });
				}
				let _form = {
					uid:this.info.uid,
					action:_action,
					amount:this.amount,
					wallet:_wallet,
					types:_types,
					remarks:this.remarks.trim()
				}
				this.actionFunc(_form);
			},
			WalletTypeChange(e){
				if(e == '红钻钱包'){
					this.record.types = 1;
				}else if(e == '蓝钻钱包'){
					this.record.types = 2;
				}
				this.getRecord(true);
			},
			getRecord(_init = false){
				if(_init){
					this.record.page = 1;
					this.record.limit = 10;
				}
				let _this = this;
				_this.loading = true;
				_this.$api.post("/User/getBalanceRecord", _this.record).then(res=>{
					_this.loading = false;
					if(res.code == 200){
						_this.tableData = res.data.list;
						_this.info.gold = res.data.gold;
						_this.info.balance = res.data.balance;
						_this.total = res.data.total;
					}else{
						_this.$message({ message: res.msg, type: 'warning', });
					}
				}).catch(res=>{
					_this.loading = false;
				});
			},
			handleSizeChange(e){
				this.limit = e;
				this.getRecord();
			},
			handleCurrentChange(e){
				this.record.page = e;
				this.getRecord();
			}
		}
	}
</script>

<style>
</style>